import React from 'react';
import SlidingSideBar from '../../SlidingSideBar/SlidingSideBar';
import FileExplorer from './FileExplorer';

/** Reusable sidebar around FileExplorer; pass parentFolderName for the group of files to browse. */
const FileExplorerSidebar = ({ show, onHide, parentFolderName, title, zIndex }) => {
  return (
    <SlidingSideBar zIndex={zIndex} visible={show} onClose={onHide} title={title || parentFolderName}>
      {show && <FileExplorer parentFolderName={parentFolderName} />}
    </SlidingSideBar>
  );
};

export default FileExplorerSidebar;
